import { locationHistory, previousAlerts } from './detail-notification'

const createMediaData = (alertData, mediaFilename = alertData) => ({
  alertData,
  media: [
    {
      downloadId: 1,
      mediaFilename,
      channel: 3,
      status: 'S',
      identifier: 'V',
    },
  ],
  mediaStatus: 'Success',
})

export const dataDemoDms = [
  {
    rawAlertId: 1,
    createdOn: '2024-06-12T06:46:04.000Z',
    vehicleId: 35480,
    vehicle: {
      licensePlate: 'Trackvision Pro Dashcam Howen',
      id: 35480,
      vehicleType: {
        type: 'Other',
        model: 'Other',
        category: 'Other',
        icon: 'smallTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 12001,
      },
      imei: '862798051637656',
      __typename: 'Vehicle',
    },
    alertCode: 148,
    alert: {
      alertCode: 148,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_eye_off_2.svg',
      descriptionEng: 'Verified Face',
      descriptionIdn: 'Wajah Terverifikasi',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('HW_867395078821754_20260727155225_20260727155235_-420_2.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: 1,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
  {
    createdOn: '2024-06-12T06:46:04.000Z',
    vehicleId: 35480,
    vehicle: {
      licensePlate: 'Trackvision Pro Dashcam Howen',
      id: 35480,
      vehicleType: {
        type: 'Other',
        model: 'Other',
        category: 'Other',
        icon: 'smallTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 12001,
      },
      imei: '862798051637656',
      __typename: 'Vehicle',
    },
    alertCode: 150,
    alert: {
      alertCode: 150,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_eye_off_2.svg',
      descriptionEng: 'Unverified Face',
      descriptionIdn: 'Wajah Tidak Terverifikasi',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('HW_867395078821754_20260727155403_20260727155413_-420_2.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: 1,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
  {
    createdOn: '2024-06-12T06:46:04.000Z',
    vehicleId: 16923,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 16923,
      vehicleType: {
        type: 'Other',
        model: 'Other',
        category: 'Other',
        icon: 'smallTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 6001,
      },
      imei: '862798051637656',
      __typename: 'Vehicle',
    },
    alertCode: 51,
    alert: {
      alertCode: 51,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_eye_off_2.svg',
      descriptionEng: 'Eye Closed',
      descriptionIdn: 'Mata Terpejam',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('DMS_Mata_Terpejam_EVENT_864993060037646_2024_06_29_23_56_17_I.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: 1,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 2,
    createdOn: '2024-06-12T06:45:04.000Z',
    vehicleId: 16923,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 16923,
      vehicleType: {
        type: 'Other',
        model: 'Other',
        category: 'Other',
        icon: 'smallTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 6001,
      },
      imei: '862798051637656',
      __typename: 'Vehicle',
    },
    alertCode: 56,
    alert: {
      alertCode: 56,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      descriptionEng: 'Missing Face',
      descriptionIdn: 'Keluar Dari Frame Kamera',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('DMS_Keluar_dari_Frame_EVENT_864993060033942_2024_05_03_14_47_17_I.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: 1,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 3,
    createdOn: '2024-06-12T06:44:04.000Z',
    vehicleId: 16923,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 16923,
      vehicleType: {
        type: 'Other',
        model: 'Other',
        category: 'Other',
        icon: 'smallTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 6001,
      },
      imei: '862798051637656',
      __typename: 'Vehicle',
    },
    alertCode: 55,
    alert: {
      alertCode: 55,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_phone_missed.svg',
      descriptionEng: 'Phone Calling',
      descriptionIdn: 'Sambil Menelpon',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('DMS_Menelpon_EVENT_864993060033942_2024_05_03_14_48_38_I.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: 1,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 4,
    createdOn: '2024-06-12T06:43:04.000Z',
    vehicleId: 16923,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 16923,
      vehicleType: {
        type: 'Other',
        model: 'Other',
        category: 'Other',
        icon: 'smallTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 6001,
      },
      imei: '862798051637656',
      __typename: 'Vehicle',
    },
    alertCode: 54,
    alert: {
      alertCode: 54,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_smoking.svg',
      descriptionEng: 'Smoking',
      descriptionIdn: 'Merokok',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('DMS_Merokok_EVENT_864993060033942_2022_06_22_12_00_45_I.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: 1,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 5,
    createdOn: '2024-06-12T06:42:04.000Z',
    vehicleId: 16923,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 16923,
      vehicleType: {
        type: 'Other',
        model: 'Other',
        category: 'Other',
        icon: 'smallTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 6001,
      },
      imei: '862798051637656',
      __typename: 'Vehicle',
    },
    alertCode: 53,
    alert: {
      alertCode: 53,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_driver_fatigue.svg',
      descriptionEng: 'Yawn',
      descriptionIdn: 'Menguap',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('DMS_Menguap_EVENT_864993060033942_2024_05_03_21_41_36_I.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: 1,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 6,
    createdOn: '2024-06-12T06:41:04.000Z',
    vehicleId: 16923,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 16923,
      vehicleType: {
        type: 'Other',
        model: 'Other',
        category: 'Other',
        icon: 'smallTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      device: {
        deviceCode: 6001,
      },
      imei: '862798051637656',
      __typename: 'Vehicle',
    },
    alertCode: 52,
    alert: {
      alertCode: 52,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      descriptionEng: 'Distraction',
      descriptionIdn: 'Distraksi',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('DMS_Gangguan_EVENT_864993060033942_2022_06_22_11_51_12_I.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: 1,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 7,
    createdOn: '2024-06-12T06:13:30.000Z',
    vehicleId: 35480,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 35480,
      vehicleType: {
        type: '1.3 D Face Face',
        model: 'Granmax MB',
        category: 'Mini Bus',
        icon: 'bus',
        __typename: 'VehicleType',
      },
      device: {
        deviceCode: 6001,
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      imei: '864993060037652',
      __typename: 'Vehicle',
    },
    alertCode: 110,
    alert: {
      alertCode: 110,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      descriptionEng: 'Seatbelt',
      descriptionIdn: 'Sabuk Pengaman',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('DMS_BSJ_Seatbelt.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: null,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
  {
    rawAlertId: 8,
    createdOn: '2024-06-12T06:11:30.000Z',
    vehicleId: 35480,
    vehicle: {
      licensePlate: 'DemoBSJ',
      id: 35480,
      vehicleType: {
        type: '1.3 D Face Face',
        model: 'Granmax MB',
        category: 'Mini Bus',
        icon: 'bus',
        __typename: 'VehicleType',
      },
      device: {
        deviceCode: 6001,
      },
      sensor: [
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2,3,4',
          __typename: 'SensorResponseType2',
        },
      ],
      imei: '864993060037652',
      __typename: 'Vehicle',
    },
    alertCode: 111,
    alert: {
      alertCode: 111,
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_alert_triangle.svg',
      descriptionEng: 'Face Not Detected',
      descriptionIdn: 'Wajah Tidak Terdeteksi',
      alertCategories: [{ alertCategoryId: 3 }],
      __typename: 'AlertCode',
    },
    driverId: null,
    driver: null,
    alertFlag: null,
    ...createMediaData('demo-alert-wajah-tidak-terdeteksi-blur.mp4', 'DMS_BSJ_Seatbelt.mp4'),
    formattedAlertData: null,
    latitude: -7.8593566,
    longitude: 112.7065422,
    alertTrigger: null,
    threshold: '',
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    __typename: 'RawAlert',
  },
]
